import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'



export const tipoRecursoFinanceiroList = [
    {
        id: 10,
        descricao: 'Carteira Total',
        ordem: 10,
        ordemRelatorio: 1000,
        ordemConsumo: 40,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 10,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 15, // HARDCODE.idTipoRecursoFinanceiroContaCorrente
        descricao: 'Conta Corrente',
        ordem: 15,
        ordemRelatorio: 1500,
        ordemConsumo: 39,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 15,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 20,
        descricao: 'Ações',
        ordem: 20,
        ordemRelatorio: 2000,
        ordemConsumo: 90,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        labelDividendos: '',//'Dividendos',
        labelDividendosAteAposentadoria: '',//'Os dividendos serão recebidos até a ' + LABEL.aposentadoria.toLowerCase(),
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'S',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 20,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 25, // HARDCODE.idTipoRecursoFinanceiroCOE
        descricao: 'COE',
        ordem: 25,
        ordemRelatorio: 1800,
        ordemConsumo: 92,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'S',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'S',
        informaCnpjFundo: 'S',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 25,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 27,
        descricao: 'Criptoativos',
        ordem: 27,
        ordemRelatorio: 2700,
        ordemConsumo: 93,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'S',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 27,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 28, // HARDCODE.idTipoRecursoFinanceiroCurtoPrazo
        descricao: 'Curto Prazo',
        ordem: 28,
        ordemRelatorio: 2800,
        ordemConsumo:38,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'S',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 28,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 30, // HARDCODE.idTipoRecursoFinanceiroInternacional
        descricao: 'Internacional',
        ordem: 96,
        ordemRelatorio: 1750,
        ordemConsumo: 130,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 30,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'S',//'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 40,
        descricao: 'Espécie',
        ordem: 40,
        ordemRelatorio: 4000,
        ordemConsumo: 10,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'N',
        tipoRecursoFinanceiroGrafico: 40,
        mediaPonderadaTaxaJuros: 'N',
        inventario: 'N',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 70, // HARDCODE.idTipoRecursoFinanceiroFgtsSaldo
        descricao: 'FGTS - Saldo',
        ordem: 70,
        ordemRelatorio: 7000,
        ordemConsumo: 120,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 90,
        mediaPonderadaTaxaJuros: 'N',
        inventario: 'N',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 80, // HARDCODE.idTipoRecursoFinanceiroFgtsContribuicao
        descricao: 'FGTS - Contribuição',
        ordem: 80,
        ordemRelatorio: 8000,
        ordemConsumo: 120,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'N',
        totalizaEntradaDados: 'N',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 90,
        mediaPonderadaTaxaJuros: 'N',
        inventario: 'N',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 90,
        descricao: 'FGTS',
        ordem: 90,
        ordemRelatorio: 9000,
        ordemConsumo: 120,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'N',
        totalizaEntradaDados: 'N',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 90,
        mediaPonderadaTaxaJuros: 'N',
        inventario: 'N',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 93, // HARDCODE.idTipoRecursoFinanceiroInflacao
        descricao: 'Inflação',
        ordem: 93,
        ordemRelatorio: 1630,
        ordemConsumo: 160,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'S', //'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 93,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 98,
        descricao: 'Fundos Imobiliários (FIIs)',
        ordem: 98,
        ordemRelatorio: 1700,
        ordemConsumo: 67,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'S',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'S',
        informaCnpjFundo: 'S',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 98,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 100,
        descricao: 'Fundos Investimentos',
        ordem: 100,
        ordemRelatorio: 1710,
        ordemConsumo: 70,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'S',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'S',
        informaCnpjFundo: 'S',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 100,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 101, // HARDCODE.idTipoRecursoFinanceiroFundosListados
        descricao: 'Fundos Listados',
        ordem: 101,
        ordemRelatorio: 1720,
        ordemConsumo: 65,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'S',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'S',
        informaCnpjFundo: 'S',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 101,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 103, // HARDCODE.idTipoRecursoFinanceiroMultimercado
        descricao: 'Multimercado',
        ordem: 103,
        ordemRelatorio: 10300,
        ordemConsumo: 160,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 103,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 106, // HARDCODE.idTipoRecursoFinanceiroPosFixado
        descricao: 'Pós-Fixado',
        ordem: 106,
        ordemRelatorio: 1610,
        ordemConsumo: 160,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'S', //'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 106,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 110, // HARDCODE.idTipoRecursoFinanceiroPoupanca
        descricao: 'Poupança',
        ordem: 110,
        ordemRelatorio: 11000,
        ordemConsumo: 20,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 110,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 115, // HARDCODE.idTipoRecursoFinanceiroPreFixado
        descricao: 'Pré-Fixado',
        ordem: 115,
        ordemRelatorio: 1620,
        ordemConsumo: 160,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'S', //'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 115,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 120, // HARDCODE.idTipoRecursoFinanceiroPrevidenciaPGBL
        descricao: 'Prev. Privada - PGBL',
        ordem: 120,
        ordemRelatorio: 12000,
        ordemConsumo: 100,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'S',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'S',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'S',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'S',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 120,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'N', //'S', retirado em 23/01/2025 em função da decisão do STF por 11 x 0 //HARDCODE.inventarioPrevidenciaPrivada,
        somenteITCMD: 'N',//'S', retirado em 13/12/2024 em função da decisão do STF por 11 x 0
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 130, // HARDCODE.idTipoRecursoFinanceiroPrevidenciaVGBL
        descricao: 'Prev. Privada - VGBL',
        ordem: 130,
        ordemRelatorio: 13000,
        ordemConsumo: 110,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'S',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'S',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'S',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'S',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 130,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'N',//HARDCODE.inventarioPrevidenciaPrivada,
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },

    /* Inativado e convertido em ClienteService.inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient para id 120
       nào reutilizar o id 140
        {
            id: 140, // HARDCODE.idTipoRecursoFinanceiroPrevidenciaPGBLEmpresarial
            descricao: 'Prev. Privada - PGBL Empresarial',
            ordem: 140,
            ordemRelatorio: 14000,
            tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
            informaReservaAtual: 'S',
            informaAporteDividendos: 'S',
            informaAporteEmpresa: 'S',
            informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
            informaPercRentabilidadeRecursoFinanceiro: 'S',
            //informaTaxaAnual: 'N',
            informaVencimento: 'N',
            //informaInstituicao: 'S',
            informaNomeAcao: 'N',
            informaRegimeTributacao: 'S',
            informaNomeFundo: 'N',
            informaCnpjFundo: 'S',
            permiteEntradaDados: 'S',
            totalizaEntradaDados: 'S',
            atualizaTaxaJuros: 'S',
            tipoRecursoFinanceiroGrafico: 140,
            mediaPonderadaTaxaJuros: 'S',
            inventario: 'S',//HARDCODE.inventarioPrevidenciaPrivada,
            somenteITCMD: 'S',
            destacaGraficoDiagnosticoAposentadoria: 'N',
            ativo: 'S',
        },
    */

    /* Inativado e convertido em ClienteService.inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient para id 130
       nào reutilizar o id 145
        {
            id: 145, // HARDCODE.idTipoRecursoFinanceiroPrevidenciaVGBLEmpresarial
            descricao: 'Prev. Privada - VGBL Empresarial',
            ordem: 145,
            ordemRelatorio: 14500,
            tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
            informaReservaAtual: 'S',
            informaAporteDividendos: 'S',
            informaAporteEmpresa: 'S',
            informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
            informaPercRentabilidadeRecursoFinanceiro: 'S',
            //informaTaxaAnual: 'N',
            informaVencimento: 'N',
            //informaInstituicao: 'S',
            informaNomeAcao: 'N',
            informaRegimeTributacao: 'S',
            informaNomeFundo: 'N',
            informaCnpjFundo: 'S',
            permiteEntradaDados: 'S',
            totalizaEntradaDados: 'S',
            atualizaTaxaJuros: 'S',
            tipoRecursoFinanceiroGrafico: 145,
            mediaPonderadaTaxaJuros: 'S',
            inventario: 'N',//HARDCODE.inventarioPrevidenciaPrivada,
            somenteITCMD: 'N',
            destacaGraficoDiagnosticoAposentadoria: 'N',
            ativo: 'S',
        },
    */

    {
        id: 150, // HARDCODE.idTipoRecursoFinanceiroRendaFixa
        descricao: 'Renda Fixa',
        ordem: 150,
        ordemRelatorio: 1600,
        ordemConsumo: 160,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'S',
        informaVencimento: 'S',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 150,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 152, // HARDCODE.idTipoRecursoFinanceiroRendaVariavel
        descricao: 'Renda Variável',
        ordem: 152,
        ordemRelatorio: 1900,
        ordemConsumo: 160,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 152,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 155, // HARDCODE.idTipoRecursoFinanceiroSeguroVidaSobrevivencia
        descricao: 'Seguro de Vida - Sobrevivência',
        ordem: 155,
        ordemRelatorio: 15500,
        ordemConsumo: 140,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'N',
        totalizaEntradaDados: 'N',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 155,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'N',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 160,
        descricao: 'Título Público',
        ordem: 160,
        ordemRelatorio: 16000,
        ordemConsumo: 80,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'S',
        informaVencimento: 'S',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        atualizaTaxaJuros: 'S',
        tipoRecursoFinanceiroGrafico: 160,
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 900, // HARDCODE.idTipoRecursoFinanceiroOutros
        descricao: 'Outros',
        ordem: 900,
        ordemRelatorio: 90000,
        ordemConsumo: 30,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        tipoRecursoFinanceiroGrafico: 900,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 910,
        descricao: 'Formação de Reserva',
        ordem: 910,
        ordemRelatorio: 91000,
        ordemConsumo: 50,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'S',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        tipoRecursoFinanceiroGrafico: 910,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'N',
    },
    {
        id: 920, // HARDCODE.idTipoRecursoFinanceiroAporteVendaImobilizado
        descricao: 'Aporte - Venda Imobilizado',
        ordem: 920,
        ordemRelatorio: 92000,
        ordemConsumo: 51,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeUnica,
        informaReservaAtual: '0',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        tipoRecursoFinanceiroGrafico: 920,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'S',
        ativo: 'S',
    },
    {
        id: 925,
        descricao: 'Aporte - Bônus',
        ordem: 925,
        ordemRelatorio: 92500,
        ordemConsumo: 52,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeAnual,
        informaReservaAtual: '0',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        tipoRecursoFinanceiroGrafico: 925,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 930,
        descricao: 'Aporte - Recebimento Herança',
        ordem: 930,
        ordemRelatorio: 93000,
        ordemConsumo: 53,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeUnica,
        informaReservaAtual: '0',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        tipoRecursoFinanceiroGrafico: 930,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'S',
        ativo: 'S',
    },
    {
        id: 935,
        descricao: 'Aporte - Resgate Seguro de Vida',
        ordem: 935,
        ordemRelatorio: 93500,
        ordemConsumo: 54,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeUnica,
        informaReservaAtual: '0',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        tipoRecursoFinanceiroGrafico: 935,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'S',
        ativo: 'S',
    },
    {
        id: 940,
        descricao: 'Aporte - Recebimento Capital Segurado',
        ordem: 940,
        ordemRelatorio: 94000,
        ordemConsumo: 55,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeUnica,
        informaReservaAtual: '0',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        tipoRecursoFinanceiroGrafico: 940,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'S',
        ativo: 'S',
    },
    {
        id: 950, // HARDCODE.idTipoRecursoFinanceiroAporteOutros
        descricao: 'Aporte - Outros',
        ordem: 950,
        ordemRelatorio: 95000,
        ordemConsumo: 56,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: '0',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'S',
        informaPercRentabilidadeRecursoFinanceiro: 'S',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'S',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'S',
        totalizaEntradaDados: 'S',
        tipoRecursoFinanceiroGrafico: 950,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 960, // HARDCODE.idTipoRecursoFinanceiroEconomiaReceitaMensal
        descricao: 'Economia Receita Mensal',
        ordem: 960,
        ordemRelatorio: 96000,
        ordemConsumo: 58,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'N',
        totalizaEntradaDados: 'N',
        tipoRecursoFinanceiroGrafico: 960,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 970, // HARDCODE.idTipoRecursoFinanceiroFaltaBalancoNegativoReceitaDespesaDiaDia
        descricao: 'Falta para Balanço Negativo Receita x Despesa e Dia a Dia',
        ordem: 970,
        ordemRelatorio: 97000,
        ordemConsumo: null,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'N',
        totalizaEntradaDados: 'N',
        tipoRecursoFinanceiroGrafico: 970,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'N',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 980, // HARDCODE.idTipoRecursoFinanceiroAporteAtingirMetaInicioAposentadoria
        descricao: 'Aporte Atingir Meta Início ' + LABEL.aposentadoria,
        ordem: 980,
        ordemRelatorio: 98000,
        ordemConsumo: 59,
        tipoPeriodicidadeAporteDividendosDefault: '',
        informaReservaAtual: 'N',
        informaAporteDividendos: 'N',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'N',
        totalizaEntradaDados: 'N',
        tipoRecursoFinanceiroGrafico: 980,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
    {
        id: 990, // HARDCODE.idTipoRecursoFinanceiroResgateSeguroVida
        descricao: 'Resgate Seguro de Vida',
        ordem: 990,
        ordemRelatorio: 99000,
        ordemConsumo: null,
        tipoPeriodicidadeAporteDividendosDefault: HARDCODE.idTipoPeriodicidadeMensal,
        informaReservaAtual: 'N',
        informaAporteDividendos: 'S',
        informaAporteEmpresa: 'N',
        informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos: 'N',
        informaPercRentabilidadeRecursoFinanceiro: 'N',
        //informaTaxaAnual: 'N',
        informaVencimento: 'N',
        //informaInstituicao: 'N',
        informaNomeAcao: 'N',
        informaRegimeTributacao: 'N',
        informaNomeFundo: 'N',
        informaCnpjFundo: 'N',
        permiteEntradaDados: 'N',
        totalizaEntradaDados: 'N',
        tipoRecursoFinanceiroGrafico: 990,
        atualizaTaxaJuros: 'S',
        mediaPonderadaTaxaJuros: 'S',
        inventario: 'S',
        somenteITCMD: 'N',
        destacaGraficoDiagnosticoAposentadoria: 'N',
        ativo: 'S',
    },
]

export default tipoRecursoFinanceiroList